const axios = require('axios')

export default {
  methods: {
    adminRequest(options, request, callback) {
      const credentials = JSON.parse(localStorage.getItem('API_CREDENTIALS'))

      if (!credentials) {
        this.$router.push({ name: 'start' })
      }

      const requestUrl = `${process.env.VUE_APP_API}/${request}`
      const headers = {
        Authorization: `Bearer ${credentials.auth.access_token}`
      }

      const method = options && options.method || "get";
      const data = options && options.data;

      if (method.toLowerCase() === 'get') {
        return axios.get(requestUrl, { headers })
          .then(res => callback(res))
          .catch(() => {
            this.$router.push({ name: 'start' })
          })
      }

      if (method.toLowerCase() === 'post') {
        return axios.post(requestUrl, data, { headers })
          .then(res => callback(res))
          .catch(() => {
            this.$router.push({ name: 'start' })
          })
      }
    },
  }
}
